module.exports = __webpack_public_path__ + "static/media/EbitNielsen-LinhaTempo-v.869fdf11.869fdf11.png";